if (!customElements.get("nav-anchor")) {
  class NavAnchor extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        navItem: '.nav-item',
        navList: '.nav-list',
        navLink: '[data-heading]'
      };

      this.ticking = false;
      this.handleScroll = this.handleScroll.bind(this);
      this.handleNavClick = this.handleNavClick.bind(this);
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      this.removeEventListener('click', this.handleNavClick);
      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
      }
    }

    init() {
      this.navItems = Array.from(this.querySelectorAll(this.selectors.navItem));
      this.links = Array.from(this.querySelectorAll(this.selectors.navLink));
      this.navList = this.querySelector(this.selectors.navList);

      this.headingsMap = new Map();
      this.headings = [];

      this.links.forEach(link => {
        const id = link.getAttribute('data-heading');
        const headingEl = document.getElementById(id);
        const navItem = link.closest(this.selectors.navItem);

        if (headingEl && navItem) {
          this.headingsMap.set(headingEl, { navItem, link });
          this.headings.push(headingEl);
        }
      });

      if (!this.headings.length) return;

      this.addEventListener('click', this.handleNavClick);
      window.addEventListener('scroll', this.handleScroll, { passive: true });

      this.onScroll();
    }

    getOffset() {
      const stickyBarHeight = this.offsetHeight || 50;
      const header = document.querySelector('.header-wrapper') || document.querySelector('header');
      const headerHeight = header ? header.offsetHeight : 0;
      return headerHeight + stickyBarHeight + 20; //
    }

    handleScroll() {
      if (!this.ticking) {
        this.rafId = requestAnimationFrame(() => {
          this.onScroll();
          this.ticking = false;
        });
        this.ticking = true;
      }
    }

    onScroll() {
      if (!this.headings.length) return;

      const offset = this.getOffset();
      const scrollY = window.scrollY || window.pageYOffset;
      const viewportHeight = window.innerHeight;
      const pageHeight = document.documentElement.scrollHeight;

      let currentHeading = this.headings[0];

      if (scrollY + viewportHeight >= pageHeight - 30) {
        currentHeading = this.headings[this.headings.length - 1];
      } else {
        for (const heading of this.headings) {
          const top = heading.getBoundingClientRect().top;
          if (top <= offset) {
            currentHeading = heading;
          } else {
            break;
          }
        }
      }

      this.updateActiveState(currentHeading);
    }

    updateActiveState(currentHeading) {
      if (!currentHeading) return;

      const targetData = this.headingsMap.get(currentHeading);
      if (!targetData) return;

      const { navItem, link } = targetData;

      if (navItem.classList.contains('active')) return;

      this.navItems.forEach(item => item.classList.remove('active'));
      this.links.forEach(l => l.removeAttribute('aria-current'));

      navItem.classList.add('active');
      link.setAttribute('aria-current', 'location');

      this.scrollActiveItemIntoView(navItem);
    }

    scrollActiveItemIntoView(activeItem) {
      const scrollContainer = this.querySelector('.mixed-layout--mobile-scroll') || this.navList;
      if (!scrollContainer) return;

      if (scrollContainer.scrollWidth <= scrollContainer.clientWidth) return;

      const containerRect = scrollContainer.getBoundingClientRect();
      const itemRect = activeItem.getBoundingClientRect();

      const itemCenter = itemRect.left + itemRect.width / 2;
      const containerCenter = containerRect.left + containerRect.width / 2;
      const diff = itemCenter - containerCenter;

      if (Math.abs(diff) > 2) {
        scrollContainer.scrollBy({
          left: diff,
          behavior: 'smooth'
        });
      }
    }

    handleNavClick(e) {
      const link = e.target.closest(this.selectors.navLink);
      if (!link) return;

      const targetId = link.getAttribute('data-heading');
      const targetEl = document.getElementById(targetId);
      if (!targetEl) return;

      e.preventDefault();

      const offset = this.getOffset();
      const targetY = targetEl.getBoundingClientRect().top + window.scrollY - offset + 5;

      window.scrollTo({
        top: targetY,
        behavior: 'smooth'
      });

      this.updateActiveState(targetEl);

      if (history.pushState) {
        history.pushState(null, '', `#${targetId}`);
      }
    }
  }

  customElements.define("nav-anchor", NavAnchor);
}
